/**
 * Workspace home (Work mode) — the workspace's canvases + artifacts. The body is
 * the shared `WorkspaceOverview` (also used by the Plan-mode workspace home), so
 * a workspace renders identically as a folder of canvases/artifacts in either
 * mode; only the surrounding chrome differs.
 */

import { createFileRoute, useParams } from "@tanstack/react-router";

import { WorkspaceOverview } from "@/components/workspace/WorkspaceOverview";

export const Route = createFileRoute("/_app/w/$slug/")({
  component: WorkspaceHome,
});

function WorkspaceHome() {
  const { slug } = useParams({ from: "/_app/w/$slug/" });
  return <WorkspaceOverview slug={slug} />;
}
